import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule, TranslationService } from '@spartacus/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../custom-landing.module';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import { ConsignmentsPopupmodalComponent } from '../consignments-popupmodal/consignments-popupmodal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';import { groupBy } from 'rxjs';
import { WholeNumberdirectiveDirective } from 'src/app/shared/directive/commondirective.directive';



@Component({
  selector: 'app-consignments-list',
  standalone: true,
  imports: [WholeNumberdirectiveDirective,ReactiveFormsModule,CustomLandingModule, CommonModule, FormsModule, NgSelectModule, I18nModule, SharedModule, InfiniteScrollDirective],
  templateUrl: './consignments-list.component.html',
  styleUrl: './consignments-list.component.scss'
})
export class ConsignmentsListComponent implements OnInit {
  @ViewChildren('carousel')carousel!:QueryList<ElementRef<HTMLDivElement>>;
  scrollAmount=300;
  selectedLocation: any;
  selectedMaterial:any;
    searchText = null;
  showClear: boolean = false;
  sidebar: boolean;
   navigationData: string = '';
  activeTab = 'location';
  listSrc = '/images/list-view.svg';
  gridSrc = '/images/grid-view-orange.svg';
  list = false;
  grid = true;
  title: any = '';
 StatusList:any[]=[];
  portData: any[] = [];
  consignnmentMaterials: [];
  consignmentLocation: [];
  form:FormGroup;
  consignTab:any;
  enableLoader: boolean;
  MaterialsData: any;
  Materialsdata:any;
  locationsData: any;
  consignmentForm:FormGroup
  productLength: number = 0;
  locationlength: number = 0;
    checkedlocationform: UntypedFormGroup;
    checkedproductform: UntypedFormGroup;
    canScrollLeft:boolean[]=[];//to track left scroll state for each carousel
    canScrollRight:boolean[]=[];//to track right scroll state for each carousel
    constructor(private fb:FormBuilder, private ModalService: NgbModal,private toastrService: ToastrService,
      private customProfileService: CustomProfileService,private translation: TranslationService) {
   this.checkedlocationform = this.fb.group({
    checkArray: this.fb.array([])
  });
    this.checkedproductform = this.fb.group({
    checkArray: this.fb.array([])
  });

  }

  ngOnInit(): void {
        this.sidebar = true;
    this.translation
      .translate('breadcrumb.consignments.pageTitle')
      .subscribe(res => {
        this.title = res;
      });
    this.translation
      .translate('breadcrumb.consignments.breadcrumb')
      .subscribe(res => {
        this.navigationData = res;
      });
       this.getConsignment();
       this.getLocationsTabFilters();
  }
  updateAllScrollStates(){//updates scroll states for all carousels
    this.carousel.toArray().forEach((element,index)=>this.updateScrollState(index));
  }
  updateScrollState(index:number){//updates scroll state for particular index
    const element=this.carousel.toArray()[index].nativeElement;
    if(element){//
      const maxScrollLeft=element.scrollWidth-element.clientWidth;//total width - visible width
      this.canScrollLeft[index]=element.scrollLeft>10;
      this.canScrollRight[index]=element.scrollLeft<maxScrollLeft-10;
    }
  }
  onScroll(index:number){
    this.updateScrollState(index);
  }
  changePorts() {
  }
  changeStatus() {

  }
  clearAllFilter() {
    this.showClear = false;
    this.selectedLocation = [];
    this.selectedMaterial = [];
    this.searchText=null;
    this.getConsignment();
  }
  changeLocation(){
    if (
      this.selectedLocation?.length == 0 ||
      this.selectedLocation?.length == undefined
    ) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.getConsignment();
  }
  changeMaterial(){
    if (
      this.selectedMaterial?.length == 0 ||
      this.selectedMaterial?.length == undefined
    ) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.getConsignment();
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    return this.isValidLetter(k);
  }
  search() {
 const search = document.getElementById('consign-search-input') as HTMLInputElement
    search?.addEventListener('keyup', (event: KeyboardEvent) => {
     if((this.searchText.length >=5) || (this.searchText.length >=3  && event.key === 'Enter')){
      this.getConsignment();
    }
  });
  if(this.searchText.length==0){
    this.getConsignment();
  }
  }
  isValidLetter(k): any {
    return (k = 47);
  }
  filtersidebar() {
    this.sidebar = false;

  }

    changeTab(data, showMsg?): any {
    this.activeTab = data;
    if (data === 'location') {
      this.consignTab = 'locations';
    } else if (this.activeTab === 'material') {
      this.activeTab = 'material';
      this.consignTab = 'materials';
    }
    this.getConsignment();
  }

  closebar() {
    this.sidebar = true;
  }
    viewList(): any {
    this.listSrc = '/images/list-view-orange.svg';
    this.gridSrc = '/images/grid-view.svg';
    this.list = true;
    this.grid = false;
    this.getConsignment();

  }
onCheckboxlocationChange(e, id): void {
  this.locationlength = 1;
  const checkArray: UntypedFormArray = this.checkedlocationform.get(
    'checkArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkArray.push(new UntypedFormControl(e.target.value));
  } else {
    let i = 0;
    checkArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkArray.removeAt(i);
        return;
      }
      i++;
    });
    this.locationlength = 0;
  }
  
  
   this.selectedLocation =  checkArray.value;
  
  
}
  onCheckboxproductChange(e, id): void {
    this.productLength = 1;
    const checkArray: UntypedFormArray = this.checkedproductform.get('checkArray') as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
      // this.productlist.forEach(item => {
      //   if (item.name === id) {
      //     item.selected = true;
      //   }
      // })
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.productLength = 0;
    }
   this.selectedMaterial=checkArray.value 
  }

  getResults(): any {
    this.closebar();
    this.filterData();
  }
  filterData(){
    this.getConsignment();
  }
  
  getLocationsTabFilters(): void {
    this.enableLoader = true;
    this.customProfileService.getLocationTabfilters().subscribe((res) => {
      if (res) {
        this.enableLoader = false;
        this.locationsData = res.shipToLocations;
        this.Materialsdata = res.products;
        this.MaterialsData=this.Materialsdata.map(item=>
        typeof item==='string'?{name:item,selected:false}:item);
      }
      (error) => {
        this.enableLoader = false;
        this.toastrService.show(
          'Something went wrong please contact support team.'
        );
      };
    });
  }
    getConsignment() {
      this.enableLoader=true;
      const requestParams = {
          groupBy:this.activeTab == 'location' ? this.consignTab = 'locations' : this.consignTab = 'materials',
          materialId: this.selectedMaterial?.length ? this.selectedMaterial : '',
          shipToUId: this.selectedLocation?.length ? this.selectedLocation : '',
          searchText:this.searchText
          }
    this.customProfileService.getConsignmentList(requestParams).subscribe((data) => {
     this.enableLoader=false;
     // this.consignnmentMaterials = data.materials;
      // this.consignmentLocation = data.locations;
      // const response=this.activeTab==='locations'?this.consignmentLocation:this.consignnmentMaterials;
      this.buildForm(data)

    }, err => {
      this.toastrService.show('Consignment list is having some error.')
       this.enableLoader=false;

    })

  }
buildForm(data){
  const key=data.groupBy;
  const arrayData=data[key]||[];
  this.consignmentForm=this.fb.group({
    groupBy:key,
    listData:this.fb.array(
      arrayData.map((group:any)=>
      this.fb.group({
        key:group.key,
        value:this.fb.array(
          group.value?.map((item:any)=>
          this.fb.group({
            basePrice:[{value:item.basePrice,disabled:item.restrictedBaseValue},[Validators.required]],
            quantity:['',[Validators.required]],
            location:[item.location],
            materialId:[item.materialId],
            materialName:[item.materialName],
            restrictedBaseValue:[item.restrictedBaseValue],
            allowedDecimalQty:[item.allowedDecimalQty],
            stockAvailable:[item.stockAvailable],
            sequenceNumber:[item.sequenceNumber],
            shipToId:[item.shipToId],
            hasPricePeriod:[item.hasPricePeriod],
            pricePeriodStatus:[item.pricePeriodStatus],
            address:this.fb.group({
              houseNum:[item.address?.houseNum || ''],
              street:[item.address?.street || ''],
              city:[item.address?.city || ''],
              state:[item.address?.state || ''],
              pin:[item.address?.pin || ''],
              country:[item.address?.country || ''],
            })
          }))
        )
      }))
    )
  })
         setTimeout(() => this.updateAllScrollStates(),500)//to ensure viewchildren are loaded

}
get listData():FormArray{
  return this.consignmentForm?.get('listData') as FormArray
}
getValues(i:number):FormArray{
  return this.listData.at(i)?.get('value') as FormArray
}
  right(index: number) {
    const element = this.carousel.toArray()[index].nativeElement;
    if (element && this.canScrollRight[index]) {
      element.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
      setTimeout(()=>this.updateScrollState(index),400);
    }
  }
  left(index: number) {
    const element = this.carousel.toArray()[index].nativeElement;
    if (element && this.canScrollLeft[index] ) {
      element.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
      setTimeout(()=>this.updateScrollState(index),400);

    }

  }
  

    clearFilterMobile(event): void {
    this.closebar();
    const checked = false;
    this.locationsData.forEach(item => (item.selected = checked));
    this.MaterialsData.forEach(item => (item.selected = checked));
    this.selectedLocation = [];
    this.selectedMaterial = [];
    this.searchText = null;
    this.getConsignment();
  
  }
//checking
  viewGrid(): void {
    this.gridSrc = '/images/grid-view-orange.svg';
    this.listSrc = '/images/list-view.svg';
    this.grid = true;
    this.list = false;
    this.getConsignment();

  }

placebid(item:FormGroup){
  if (item.invalid) {
    item.markAllAsTouched();
  }
  const ModalRef = this.ModalService.open(ConsignmentsPopupmodalComponent, {
    centered: true,
    size: 'md',
    backdrop: 'static',
    keyboard: false,
  });
  ModalRef.componentInstance.item = item;
  ModalRef.componentInstance.popUp = 'Place Order';
  

}
}
